import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="px-6 py-10 max-w-3xl mx-auto" data-id="element-127">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="space-y-8 text-lg md:text-xl text-brand-light/90 leading-relaxed font-light" data-id="element-128">
        <p className="first-letter:text-6xl first-letter:font-serif first-letter:text-brand-accent first-letter:mr-2 first-letter:float-left" data-id="element-129">
          Estás en la cama, el bebé finalmente se durmió y el silencio en la
          habitación es tan pesado que podrías cortarlo con un cuchillo. Están
          uno al lado del otro, pero se sienten a kilómetros de distancia.
        </p>

        <p data-id="element-130">
          No es que no se quieran. Es que están agotados. La energía que antes
          usaban para mirarse a los ojos ahora se consume lavando biberones y
          discutiendo quién cambió el último pañal.
        </p>

        <div className="py-8" data-id="element-131">
          <h3 className="font-serif text-3xl md:text-4xl text-brand-accent mb-6 font-medium" data-id="element-132">
            El problema es que la paternidad ha devorado tu identidad de pareja.
          </h3>
          <p className="mb-6" data-id="element-133">
            Se han convertido en co-administradores de una pequeña empresa
            llamada "Hogar".
          </p>
          <p data-id="element-134">
            Las conversaciones se han vuelto puramente logísticas: horarios,
            facturas, purés y falta de sueño. El erotismo ha sido sustituido por
            el resentimiento silencioso y la gratitud ha sido reemplazada por
            una lista de tareas pendientes que nunca acaba.
          </p>
        </div>
      </motion.div>
    </section>;
}